import { Stack } from 'react-bootstrap';
import { CheckoutWizard } from '../../Features/Checkout/CheckoutWizard';
import { IntlProvider } from 'react-intl';
import { merchantPortalText, offerStateRegs } from '../../index';
import { getDetailedOffersOpts } from 'merchant-api/offer';
import { LoadingAnimation } from '@odmonorepo/core-components';
import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApplication } from 'merchant-api/unified';
import { AppError } from 'merchant-api';

const STATE_REGS_STATES = [ "CA", "NY" ];

export const Checkout = () => {
  const { applicationData, isLoadingApplication, query } = useApplication(["APPROVED"]);
  const { data: detailedOffersData, isLoading: isLoadingDetailedOffers } = useQuery({...getDetailedOffersOpts(applicationData?.id)});
  useEffect(() => {query.refetch()}, []);

  if (isLoadingApplication || isLoadingDetailedOffers || !detailedOffersData?.data?.customerData?.businessState) {
    return <div className='m-auto'><LoadingAnimation /></div>;
  }

  if (!detailedOffersData?.hasOffers) throw AppError.NoOffer;

  const useStateRegLanguage = STATE_REGS_STATES.includes(detailedOffersData?.data?.customerData?.businessState);
  return (
    <IntlProvider locale="en" messages={useStateRegLanguage ? offerStateRegs : merchantPortalText}>
      <Stack gap={4}>
        <CheckoutWizard/>
      </Stack>
    </IntlProvider>
  );
}

export default Checkout;
